import React, { Component } from 'react'

export default class PossibleDisease extends Component {
    constructor(props) {
        super(props);
      

    }
    render() {
        const { predictionsRes } = this.props;
        // console.log(predictionsRes)
        return (
            <>
                {predictionsRes?.disease_predictions?.diseases?.length ?
                    <div className='prediction_sec '>
                        <h3 className=''>Possible Diseases</h3>
                     
                            <div className=' '>
                                {predictionsRes?.disease_predictions?.diseases?.map((val, index) =>
                                    <div className='prediction_2 mt-1' key={index}>
                                        <h5 className="text-primary">{val?.name}</h5>
                                        <div className="text-muted">
                                            {val?.symptoms?.map((val2, index2) =>
                                                <p className="mb-1" style={{ color: 'black' }} key={index2}>
                                                    <i className="mdi mdi-circle-medium align-middle text-primary me-1" />{" "}
                                                    {val2}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}

                         
                        </div>
                    </div> : ''}
            </>
        )
    }
}
